(function () {
  'use strict';
  // Uses the native Termly advertising preference; no checkout checkbox.
  var enabled = true;
  if (!enabled) return;
  if (window.__rrxFirstPartyAdVisit) return;
  window.__rrxFirstPartyAdVisit = true;
  var gateName, gate, attempts = 0, visitAttempted = false, lastQueued = null;
  var queue = Promise.resolve();
  var origin;
  try { origin = new URL(window.location.href).origin; } catch (_) { return; }
  if (origin === 'https://restartrx.com') gateName = '__rrxShopifyConsent';
  else if (origin === 'https://start.restartrx.com') gateName = '__rrxGhlConsent';
  else return;
  var marker = document.getElementById('rrx-first-party-ad-visit');
  function status(value) { if (marker) marker.setAttribute('data-rrx-ad-visit-status', value); }
  function resolved() {
    try { return gate === window[gateName] && gate.ready() === true && gate.resolved() === true; }
    catch (_) { return false; }
  }
  function allowed() {
    try { return navigator.globalPrivacyControl !== true && resolved() && gate.allowed() === true; }
    catch (_) { return false; }
  }
  function candidate() {
    if (!allowed()) return null;
    try {
      var url = new URL(window.location.href);
      if (url.origin !== origin || url.pathname !== '/' || url.hash) return null;
      var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
      var seen = new Set(), valid = true, campaign = {}, click = null;
      url.searchParams.forEach(function (value, key) {
        if (seen.has(key)) valid = false;
        seen.add(key);
        if (key === 'fbclid') { if (!/^[A-Za-z0-9_-]{1,512}$/.test(value)) valid = false; else click = value; }
        else if (fields.indexOf(key) === -1) valid = false;
        else {
          if (key === 'utm_source' && !/^(facebook|instagram|fb|ig|meta)$/.test(value)) valid = false;
          if (key === 'utm_medium' && !/^(paid_social|cpc|paid)$/.test(value)) valid = false;
          if (key !== 'utm_source' && key !== 'utm_medium' && !/^\d{1,30}$/.test(value)) valid = false;
          campaign[key] = value;
        }
      });
      if (!valid || !click || !campaign.utm_source || !campaign.utm_medium || !campaign.utm_campaign) return null;
      if (document.referrer) {
        var ref = new URL(document.referrer);
        var hosts = ['www.facebook.com', 'facebook.com', 'l.facebook.com', 'm.facebook.com', 'www.instagram.com', 'instagram.com', 'l.instagram.com', 'eventsmanager.facebook.com'];
        hosts.push(new URL(origin).host);
        if (origin === 'https://start.restartrx.com') hosts.push('restartrx.com');
        if (ref.protocol !== 'https:' || ref.username || ref.password || ref.pathname !== '/' || ref.search || ref.hash || hosts.indexOf(ref.host) === -1) return null;
      }
      return { fbclid: click, campaign: campaign, consentVersion: 2, consentSource: 'termly' };
    } catch (_) { return null; }
  }
  function post(path, payload) {
    return window.fetch('https://pay.restartrx.com/api/measurement/' + path, {
      method: 'POST', mode: 'cors', credentials: 'include', cache: 'no-store', referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/json', 'X-RRX-Measurement': 'ad-visit-v1' }, body: JSON.stringify(payload)
    });
  }
  async function recordVisit() {
    var current = candidate();
    if (!current) { status('visit-blocked-before-request'); return; }
    // This temporary comparison belongs only to this in-flight operation. No
    // URL/click, client timestamp or opaque cookie is retained in browser storage.
    var comparison = JSON.stringify(current);
    var response = await post('visit', current);
    current = null;
    if (response.status === 202) {
      // Bootstrap sets only an empty pending HttpOnly server cookie. Re-read the
      // genuine current URL and current consent before committing any click.
      current = candidate();
      if (!current || JSON.stringify(current) !== comparison) { status('bootstrap-not-committed'); return; }
      response = await post('visit', current);
      current = null;
    }
    comparison = null;
    status(response.status === 204 ? 'visit-accepted' : 'visit-not-accepted');
  }
  function withdraw() {
    if (lastQueued === 'withdraw') return;
    lastQueued = 'withdraw';
    queue = queue.then(async function () {
      var response = await post('withdraw', {});
      status(response.status === 204 ? 'withdrawal-accepted' : 'withdrawal-not-accepted');
    }).catch(function () { status('withdrawal-unverified'); });
  }
  function sync() {
    if (navigator.globalPrivacyControl === true) { withdraw(); return; }
    if (!resolved()) { status('waiting-consent'); return; }
    if (!allowed()) { withdraw(); return; }
    if (visitAttempted || !candidate()) return;
    visitAttempted = true; lastQueued = 'visit';
    // One bootstrap plus one commit maximum. Never retry an indeterminate
    // network failure or replace a rejected/ambiguous server cookie.
    queue = queue.then(recordVisit).catch(function () { status('visit-unverified'); });
  }
  function bind() {
    if (navigator.globalPrivacyControl === true) { withdraw(); return; }
    var api = window[gateName];
    if (!api || typeof api.ready !== 'function' || typeof api.resolved !== 'function' || typeof api.allowed !== 'function' || typeof api.subscribe !== 'function') {
      attempts++; status('waiting-consent-api');
      if (attempts < 80) window.setTimeout(bind, 250); else status('consent-api-unavailable');
      return;
    }
    gate = api; gate.subscribe(sync);
    window.addEventListener('pageshow', sync);
    window.addEventListener('popstate', sync);
    document.addEventListener('visibilitychange', sync);
    document.addEventListener('click', sync, true);
    sync();
  }
  bind();
}());
